import { FC, useRef, useEffect } from 'react';
// import Link from 'next/link';
import Layout from '@/components/layout/Layout';
import BookBreadcrumbs from '@/components/ui/book-breadcrumbs/BookBreadcrumbs';
import BookCardImg from '@/components/ui/book-card-img/BookCardImg';
import RatingStars from '@/components/ui/book-info/rating-stars/RatingStars';
import BtnsReviewQuote from '@/components/ui/btns-review-quote/BtnsReviewQuote';
import LitresWidget from '@/components/ui/litres-widget/LitresWidget';
import ReadBanner from '@/components/ui/banners/read-banner/ReadBanner';
import Pagination from '@/components/ui/pagination/Pagination';
import { getAuthorFullName } from '@/helpers/helpers';
import { IBookDetailData } from '@/interfaces/bookDetail.interface';
import { IRead } from '@/interfaces/read.interface';
import styles from './ReadDetail.module.scss';
import BtnDownload from '@/components/ui/btn-download/BtnDownload';
import { BTN_READ_ONLINE_LFROM, READER_WIDGET_LFROM } from '@/helpers/variables';
import ReadJsonMarkup from './read-json-markup/ReadJsonMarkup';

interface ReviewsDetailPage {
  book: IBookDetailData;
  read: IRead;
  pageNumber?: string;
}

const ReadDetail: FC<ReviewsDetailPage> = ({ book, read, pageNumber }) => {
  const bookData = book.book;
  const { first_name, middle_name, last_name } = book.author;
  const authorFullName = getAuthorFullName(first_name, middle_name, last_name);

  const currentPage = read.page;
  const pagesCount = read.pages;

  //Временное решение пока нет алиаса для кнопки литрес
  // const replaceId = new RegExp(`-${book.id}`);
  // const replaceAliasWord = new RegExp('kniga-');
  // const litresAliasCutId = book.alias.replace(replaceId, '');
  // const litresAlias = litresAliasCutId.replace(replaceAliasWord, '');

  const refReadContent = useRef<HTMLDivElement>(null);

  const SEO_TITLE = `Книга ${bookData.title} - читать онлайн бесплатно, автор ${authorFullName}${currentPage > 1 ? `. Cтраница ${currentPage}` : ``}`;
  const SEO_DESCRIPTION = `${authorFullName} «${bookData.title}» 📚 читать онлайн эту и другие книги автора бесплатно и без регистрации ✔ на литературном сетевом ресурсе Fantasy Worlds.${currentPage > 1 ? ` Cтраница ${currentPage}` : ``}`;
  const SEO_CANONICAL = `/lib/id${book.id}/read`;
  const SEO_COVER = `https://fantasy-worlds.ru/covers/${bookData.external_id}.jpg`;

  const createMarkup = (c: string) => {
    return { __html: c };
  };

  let renderBannersOnce = true;

  useEffect(() => {
    // Баннер yandex
    if (renderBannersOnce) {
      const paragraphs = refReadContent.current?.querySelectorAll('p');
      const txtImages = refReadContent.current?.querySelectorAll('img');

      if (pageNumber === undefined && txtImages !== undefined && txtImages.length > 0) {
        txtImages[0].style.display = 'none';
      }

      txtImages?.forEach((item) => {
        item.style.maxWidth = '350px';
        if (item.parentElement) {
          item.parentElement.style.cssText = 'text-align: left; margin: 5px 0;';
        }
      });

      if (paragraphs !== undefined && paragraphs?.length > 0) {
        const middleParagraph = paragraphs[Math.ceil(paragraphs.length / 2)];

        const renderMiddleBanner = (idName: string, className: string) => {
          const yandexBanner = document.createElement('div');
          yandexBanner.setAttribute('id', idName);
          yandexBanner.setAttribute('data', className);

          middleParagraph.after(yandexBanner);
        };
        renderMiddleBanner('yandex_rtb_R-A-1489660-7', 'read-banner-desktop');
        renderMiddleBanner('yandex_rtb_R-A-1489660-8', 'read-banner-mobile');
      }
    }
    renderBannersOnce = false;
  });

  const hideLitresWidgets = book.book.webtoon || book.hide_litres_data || book.book.allow_full_free === 1;

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} cover={SEO_COVER}>
      {!!book.book && <ReadJsonMarkup book={book} authorName={authorFullName} />}
      <BookBreadcrumbs bookTitle={book.book.title} bookId={book.id} authorFullName={authorFullName} authorId={book.author.id} genres={book.genres} />
      <Pagination pagesCount={pagesCount ?? 0} postName={`lib/id${book.id}/read/`} />
      <div className={styles.readOnlineCard}>
        <div className={styles.readOnlineCard__img}>
          <div className={`${styles.readOnlineCard__title} ${styles.readOnlineCard__title_mob}`}>{bookData.title}</div>
          <div className={styles.readOnlineCard__item}>
            <div className={styles.readOnlineCard__imgWrap}>
              <BookCardImg type={book.book.type} freeVersion={book.book.allow_full_free} coverId={bookData.external_id} title={bookData.title} bookId={book.id} retelling={!!book.retelling_text} extraClassName="imgWrap_read" />
              <div className={styles.readOnlineCard__imgControls}>
                <RatingStars rating={book.rating} title={bookData.title} id={book.id} />
                <BtnsReviewQuote extraClassName="btnsReviewQuote_read" reviewLink={`/lib/id${book.id}#bookReviewForm`} />
              </div>
            </div>

            {!hideLitresWidgets && (
              <div className={styles.litresWidget}>
                <div id="widget">
                  <LitresWidget bookTitle={book.book.title} lfrom={Number(READER_WIDGET_LFROM)} authorName={authorFullName} />
                </div>
              </div>
            )}
          </div>
        </div>
        <div className={styles.readOnlineCard__desc}>
          <h1 className={styles.readOnlineCard__title}>{bookData.title}</h1>
          <div className={styles.readOnlineCard__txt}>
            <div data-book-reader-container className={styles.readBookContainer}>
              <div data-book-reader ref={refReadContent} className={styles.readOnlineCard__txt} dangerouslySetInnerHTML={createMarkup(read.content)}></div>
              <ReadBanner />
            </div>
          </div>
          {currentPage === pagesCount && !book.hide_litres_data && book.book.allow_full_free === 0 && (
            <div className={styles.readOnlineCard__trialBlock}>
              <p>Вы ознакомились с фрагментом книги.</p>
              <p>Для бесплатного чтения открыта только часть текста.</p>
              <p>Приобретайте полный текст книги у нашего партнера:</p>

              <div className={styles.readOnlineCard__btn}>
                <BtnDownload name="Купить и скачать всю книгу" externalId={String(book.book.external_id)} lfrom={BTN_READ_ONLINE_LFROM} />
              </div>
              {/* <Link prefetch={false} target="_blank" className={styles.readOnlineCard__trialLink} href={`https://www.litres.ru/pages/biblio_book/?art=${book.book.external_id}&lfrom=974764102`}>
                Полная версия книги
              </Link> */}
              {book.files.length > 0 && <p>{`Всего ${book.files.length} форматов`}</p>}
            </div>
          )}
          {book.hide_litres_data && (
            <>
              <br />
              <p>Вы ознакомились с фрагментом книги.</p>
            </>
          )}
        </div>
      </div>
      <Pagination pagesCount={pagesCount ?? 0} postName={`lib/id${book.id}/read/`} />
    </Layout>
  );
};

export default ReadDetail;
